import * as React from 'react';
import styled from 'styled-components';
import * as constants from '@latitude/core/utils/constants';
var StyledSpan = /*#__PURE__*/styled.span.withConfig({
  displayName: "Span__StyledSpan",
  componentId: "sc-1m8ff22-0"
})(["display:", ";", ";"], constants.DISPLAY.INLINE, function (_ref) {
  var fontWeight = _ref.fontWeight;
  return fontWeight ? "font-weight: " + fontWeight + ";" : '';
});

var Span = function Span(props) {
  return /*#__PURE__*/React.createElement(StyledSpan, props, props.children);
};

export default Span;